import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_key_storage_view = _resolveComponent("key-storage-view")!
  const _component_modal = _resolveComponent("modal")!
  const _component_key_storage_edit = _resolveComponent("key-storage-edit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSelector())),
      "data-testid": "open-selector-btn"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _cache[4] || (_cache[4] = _createTextVNode("Select… ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "glyphicon glyphicon-folder-open" }, null, -1))
        ])
      ]),
      _: 3
    }),
    _createVNode(_component_modal, {
      id: "storage-file",
      modelValue: _ctx.modalOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalOpen) = $event)),
      "before-close": _ctx.beforeModalClose,
      title: "Select a Storage File",
      disabled: "readOnly",
      "auto-focus": "",
      "append-to-body": "",
      "cancel-text": "Cancel",
      "ok-text": "Save"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_key_storage_view, {
          ref: "keyStorageViewRef",
          "read-only": _ctx.readOnly,
          "root-path": _ctx.rootPath,
          "allow-upload": _ctx.allowUpload,
          "model-value": _ctx.modelValue,
          "storage-filter": _ctx.storageFilter,
          "onUpdate:modelValue": _ctx.onSelectedKeyChange,
          onOpenEditor: _ctx.openEditor
        }, null, 8, ["read-only", "root-path", "allow-upload", "model-value", "storage-filter", "onUpdate:modelValue", "onOpenEditor"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_modal, {
      id: "storageuploadkey",
      ref: "modalEdit",
      modelValue: _ctx.modalEdit,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalEdit) = $event)),
      title: "Add or Upload a Key",
      footer: false,
      "auto-focus": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_key_storage_edit, {
          "upload-setting": _ctx.uploadSetting,
          "onUpdate:uploadSetting": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uploadSetting) = $event)),
          "root-path": _ctx.rootPath,
          onCancelEditing: _ctx.handleCancelEditing,
          onFinishEditing: _ctx.handleFinishEditing
        }, null, 8, ["upload-setting", "root-path", "onCancelEditing", "onFinishEditing"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}